import { DashboardFilterForm, DashboardSearchForm } from 'types';

export function populateSubmitSearch({
  codes,
  cpf,
  email,
  ean,
}: DashboardSearchForm) {
  return {
    codes: codes || undefined,
    cpf: cpf || undefined,
    email: email || undefined,
    ean: ean || undefined,
  };
}

export function populateSubmitDashboardFilter({
  startDate,
  endDate,
  salesModes,
  statuses,
  deliveryModes,
}: DashboardFilterForm) {
  return {
    startDate: startDate || undefined,
    endDate: endDate || undefined,
    salesModes: salesModes.join(',') || undefined,
    statuses: statuses.join(',') || undefined,
    deliveryModes: deliveryModes.join(',') || undefined,
  };
}
